import React from 'react';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import HeaderNavigationDesktop from 'components/commercetools-ui/organisms/header/header-navigation/header-navigation-desktop';
import HeaderNavigationMobile from 'components/commercetools-ui/organisms/header/header-navigation/header-navigation-mobile';
import { HeaderProps } from 'components/commercetools-ui/organisms/header/types';
import Quicksearch from './quicksearch';
import AccountButton from './utility-section/account-button';
import CartButton from './utility-section/cart-button';
import SearchButton from './utility-section/search-button';
import WishlistButton from './utility-section/wishlist-button';
import HeaderLogo from '../../../icons/header-logo';

const CommercetoolsSearch = dynamic(() => import('components/commercetools-ui/atoms/search'));

const Header: React.FC<HeaderProps> = ({ dataSource }) => {
  const Search = CommercetoolsSearch;
  const headerNav = dataSource.dataSource;
  return (
    <div className="h-[--header-mobile-size] lg:h-[--header-desktop-size]">
      <header className="fixed z-50 h-[--header-mobile-size] w-full bg-primary-cream lg:absolute lg:left-0 lg:top-0 lg:h-[--header-desktop-size]">
        <div className="mx-auto flex items-center justify-between p-4 lg:max-w-[--page-max-width]">
          <div className="flex w-1/4 justify-start">
            <HeaderNavigationMobile className="flex lg:hidden" headerNav={headerNav} />
            <div className="relative hidden w-full max-w-[267px] lg:block">
              <Quicksearch className="w-full" />
            </div>
          </div>

          <div className="flex w-2/4 justify-center">
            <Link href={'/'} aria-label="Header Logo">
              <HeaderLogo className="relative flex h-[54px] w-full max-w-[190px] lg:h-[98px] lg:max-w-[350px]" />
            </Link>
          </div>

          <div className="flex w-1/4 justify-end">
            <div className="relative top-[6px] flex items-center gap-5 lg:items-end">
              <div className="hidden flex-col items-center justify-center lg:flex">
                <AccountButton />
              </div>

              <div className="hidden flex-col items-center gap-2 py-3 lg:flex">
                <WishlistButton />
              </div>

              <div className="flex lg:hidden">
                <SearchButton />
              </div>

              <div className="flex flex-col items-center justify-center">
                <CartButton />
              </div>
            </div>
          </div>
        </div>

        <HeaderNavigationDesktop headerNav={headerNav} />
      </header>
    </div>
  );
};
export default Header;
